import { assertNever } from "../assert-never";
import type { StorageItemImageId } from "../storage-items/storage-item-images/storage-item-image-id";
import type { StorageItemImageReference } from "../storage-items/storage-item-images/storage-item-image-reference";
import type { Page } from "./page";

const parsePagePreviewImage = (
    page: Page | undefined,
): StorageItemImageId | StorageItemImageReference | undefined => {
    if (!page) return undefined;
    for (const blockId of page.blockSortOrder) {
        const block = page.blocks[blockId];
        if (!block) continue;
        switch (block.type) {
            case "POSTER_PAGE_BLOCK":
                if (block.posterImage) return block.posterImage;
                break;
            case "CONTENT_AUTO_PAGE_BLOCK":
            case "SINGLE_CONTENT_PAGE_BLOCK":
            case "HEADER_PAGE_BLOCK":
            case "HEADER_PAGE_BLOCK_V2":
            case "FOOTER_PAGE_BLOCK":
            case "SPACER_PAGE_BLOCK":
                if (block.backgroundImage) return block.backgroundImage;
                break;
            default:
                assertNever(block);
        }
    }
    return undefined;
};

export { parsePagePreviewImage };
